import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import * as colorLegendsActions from '../actions/color-legends';
import { LegendService } from '../services/legend.service';
import { FngSnackbarService } from '@festo-ui/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ColorLegendsEffects {
  private actions$ = inject(Actions);
  private legendService = inject(LegendService);
  private snackbar = inject(FngSnackbarService);
  private translate = inject(TranslateService);

  loadPalette$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(colorLegendsActions.loadPalette),
      switchMap(() =>
        this.legendService.getPalette().pipe(
          map(palette => colorLegendsActions.loadPaletteSuccess({ palette })),
          catchError(error => of(colorLegendsActions.loadPaletteFail({ error })))
        )
      )
    )
  );

  updateTaskLegend$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(colorLegendsActions.updateTaskLegends),
      switchMap(action =>
        this.legendService.updateTaskLegends(action.legends).pipe(
          map(() => colorLegendsActions.updateTaskLegendsSuccess()),
          catchError(error => of(colorLegendsActions.updateTaskLegendsFail({ error })))
        )
      )
    )
  );

  showUpdateSuccessSnack$: Observable<Action> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(colorLegendsActions.updateTaskLegendsSuccess),
        tap(() =>
          this.snackbar.snack({
            text: this.translate.instant('COMMON.UPDATE_SUCCESS'),
            showClose: true,
            type: 'info'
          })
        )
      ),
    { dispatch: false }
  );

}
